import Vue from "vue";
import VueRouter from "vue-router";
import RSBookListing from "./RSBookListing/RSBookListing.vue";
import RSCommentaryListing from "./RSCommentaryListing/RSCommentaryListing.vue";
import RSFestivalListing from "./RSFestivalListing/RSFestivalListing.vue";
import RSJewishThoughtListing from "./RSJewishThoughtListing/RSJewishThoughtListing.vue";
import RSMoralVoiceListing from "./RSMoralVoiceListing/RSMoralVoiceListing.vue";
import RSNewsListing from "./RSNewsListing/RSNewsListing.vue";
import RSTributeListing from "./RSTributeListing/RSTributeListing.vue";
import RSVideoListing from "./RSVideoListing/RSVideoListing.vue";
import RSQuoteListing from "./RSQuoteListing/RSQuoteListing.vue";
import RSCCFEListing from "./RSCCFEListing/RSCCFEListing.vue";
import RSChaggimListing from "./RSChaggimListing/RSChaggimListing.vue";
import RSNewsTicker from "./RSNewsTicker/RSNewsTicker.vue";
import RSSearchAutocomplete from "./RSSearchAutocomplete/RSSearchAutocomplete.vue";
import RSSearchResults from "./RSSearchResults/RSSearchResults.vue";
import RSWhiteboardAnimationListing from "./RSWhiteboardAnimationListing/RSWhiteboardAnimationListing.vue";
// import RSVideos2023 from "./RSVideos2023/RSVideos2023.vue";
import RSParshaListing from "./RSParshaListing/RSParshaListing.vue";

Vue.config.productionTip = true;
Vue.use(VueRouter);
Vue.prototype.window = window;

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: `/:filter1/:filter2/:filter3/:filter4/:filter5/`,
    },
  ],
});

window.mountVueComponent = function (el) {
  const elVueComponent = el.dataset.vueComponent;
  const elProps = {
    baseURL: el.dataset.baseUrl ? el.dataset.baseUrl : "/",
    baseSeries: el.dataset.baseSeries ? el.dataset.baseSeries : "/",
    tickerData: el.dataset.tickerData,
    slug: el.dataset.slug,
    lang: el.dataset.lang,
    parsha: el.dataset.parsha,
    series: el.dataset.series,
    year: el.dataset.year,
    isFamilyEdition: el.dataset.isFamilyEdition,
  };
  let elVueComponentRef;
  switch (elVueComponent) {
    case "RSBookListing":
      elVueComponentRef = RSBookListing;
      break;
    case "RSCommentaryListing":
      elVueComponentRef = RSCommentaryListing;
      break;
    case "RSFestivalListing":
      elVueComponentRef = RSFestivalListing;
      break;
    case "RSJewishThoughtListing":
      elVueComponentRef = RSJewishThoughtListing;
      break;
    case "RSMoralVoiceListing":
      elVueComponentRef = RSMoralVoiceListing;
      break;
    case "RSNewsListing":
      elVueComponentRef = RSNewsListing;
      break;
    case "RSTributeListing":
      elVueComponentRef = RSTributeListing;
      break;
    case "RSVideoListing":
      elVueComponentRef = RSVideoListing;
      break;
    case "RSQuoteListing":
      elVueComponentRef = RSQuoteListing;
      break;
    case "RSCCFEListing":
      elVueComponentRef = RSCCFEListing;
      break;
    case "RSChaggimListing":
      elVueComponentRef = RSChaggimListing;
      break;
    case "RSNewsTicker":
      elVueComponentRef = RSNewsTicker;
      break;
    case "RSWhiteboardAnimationListing":
      elVueComponentRef = RSWhiteboardAnimationListing;
      break;
    // case "RSVideos2023":
    //   elVueComponentRef = RSVideos2023;
    //   break;
    case "RSParshaListing":
      elVueComponentRef = RSParshaListing;
      break;
    default:
      return;
  }
  new Vue({
    router,
    render: (h) =>
      h(elVueComponentRef, {
        props: elProps,
      }),
  }).$mount("#" + el.id);
};

window.mountSearchAutocomplete = function (data) {
  return new Vue({
    router,
    render: (h) =>
      h(RSSearchAutocomplete, {
        props: data,
      }),
    data: data,
  }).$mount("#rs-searchautocomplete-mountpoint");
};

window.mountSearchResults = function (data) {
  return new Vue({
    router,
    render: (h) =>
      h(RSSearchResults, {
        props: data,
      }),
    data: data,
  }).$mount("#rs-searchresults-mountpoint");
};
